<!--
발송작업 > 검수 요청사항
-->
<template>
    <div class="uk-flex">
        <div class="title">
            <i class="material-icons">comment</i>
            검수 요청사항
        </div>
        <div class="body uk-width-expand">
            <request
                v-for="req in requests"
                :key="req.id"

                :request="req.request"

            >
            </request>
        </div>
    </div>
</template>

<script>
    export default {
        components: {
            'request': require('./request.vue').default,
        },
        props: {
            // 검수요청사항 object 배열
            requests: Array,
        },
        data: function () {
            return {
            };
        },
        computed: {
            /**
             * css 클래스명 object
             */
            classObj: function () {
                return {
                    memo: true,
                    checked: this.checked,
                };
            },
        },
        methods: {
        },
    }
</script>

<style lang="scss" scoped>
.title {
    text-align: left;
    width: 12rem;
    color: #000;
    font-size: 1.25rem;

    margin-right: 2rem;

    .material-icons {
        font-size: 1.75rem;
    }
}
</style>